(function () {
  function getParam(name) {
    var search = window.location.search || '';
    var params = new URLSearchParams(search);
    if (params.has(name)) return params.get(name);

    var hash = window.location.hash || '';
    if (hash.startsWith('#?')) hash = hash.slice(2);
    else if (hash.startsWith('#')) hash = hash.slice(1);
    var hparams = new URLSearchParams(hash);
    return hparams.get(name);
  }

  var heroEl = document.getElementById('redeem-product-hero');
  if (!heroEl) return; // Section not rendered


  var handle = getParam('handle');

  var imgEl = document.getElementById('redeem-hero-img');
  var titleEl = document.getElementById('redeem-title');
  var descEl = document.getElementById('redeem-desc');

  if (!handle) {
    heroEl.style.display = "none";
    return;
  }

  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function (r) { if (!r.ok) throw new Error('Not found'); return r.json(); })
    .then(function (p) {
      titleEl.textContent = p.title || '';

      var desc = p.body_html || p.description || '';
      if (desc) descEl.innerHTML = desc;

      var imgSrc = '';
      if (Array.isArray(p.images) && p.images.length) {
        var first = p.images[0];
        imgSrc = (typeof first === 'string') ? first : (first && first.src) || '';
      }
      if (!imgSrc && p.image) {
        imgSrc = (typeof p.image === 'string') ? p.image : (p.image && p.image.src) || '';
      }
      if (!imgSrc && p.featured_image) {
        imgSrc = (typeof p.featured_image === 'string') ? p.featured_image : (p.featured_image && p.featured_image.src) || '';
      }

      if (imgSrc) {
        imgEl.src = imgSrc;
        imgEl.alt = p.title ? (p.title + ' — hero image') : 'Product image';
        imgEl.style.display = '';
      }
    })
    .catch(function () {
      titleEl.textContent = 'Product not found';
    });
})();

// --------------------- Redeem flow -------------------------------
document.addEventListener('DOMContentLoaded', function () {
  var cfg = {};
  var cfgEl = document.getElementById('redeem-config');
  if (cfgEl) {
    try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) {}
  }

  var btn = document.getElementById('submit_redeem');
  if (!btn) return; // No redeem button on the page

  btn.addEventListener('click', function (event) {
    event.preventDefault();

    var isValid = validateForm();
    if (!isValid) {
      btn.classList.add('disabled-button');
      return;
    }

    var activitysku = getUTMParameter("activity_sku");
    var giftcardsku = getUTMParameter("sku");

    var giftcardvalue = null;
    if (activitysku == 30177 || activitysku === '30177') {
      giftcardvalue = 100;
    } else if (cfg.capturePassSwapGiftCardValue && Number(cfg.capturePassSwapGiftCardValue) > 0) {
      giftcardvalue = Number(cfg.capturePassSwapGiftCardValue);
    }

    var customerfname  = document.getElementById('contact_first_name')?.value || '';
    var customerlname  = document.getElementById('contact_last_name')?.value  || '';
    var customeremail  = document.getElementById('contact_email')?.value      || '';
    var customerphone  = document.getElementById('contact_phone')?.value      || '';

    var encryptedid = getUTMParameter("encrypted_id") || -1;
    var voucherid   = getUTMParameter("voucher_id") || cfg.passId || -1;

    if(cfg.isCompound) {
      request_redeem_compound(
        encryptedid,
        voucherid,
        activitysku,
        customeremail,
        customerfname,
        customerlname,
        customerphone,
        cfg.passpin,     // from Liquid
        cfg.timestamp    // from Liquid
      );
    } else {
      request_redeem_giftcard(
        encryptedid,
        voucherid,
        giftcardsku,
        activitysku,
        giftcardvalue,
        customeremail,
        customerfname,
        customerlname,
        customerphone,
        cfg.passpin,     // from Liquid
        cfg.timestamp    // from Liquid
      );
    }
  });

  function getUTMParameter(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function validateForm() {
    var form = document.querySelector('form');
    var errorMessage = document.getElementById('errorMessage');
    var requiredInputs = document.querySelectorAll('input[required]');
    var isValid = true;
    var isPhoneValid = true;
    errorMessage.textContent = "";

    requiredInputs.forEach(function (input) {
      input.classList.remove('error');

      if (input.id === "contact_phone") {
        var pattern = /^\+[1-9]\d{1,14}$/;
        if (!pattern.test(input.value)) {
          input.classList.add('error');
          isPhoneValid = false;
          isValid = false;
        }
      }

      if (!input.value.trim()) {
        input.classList.add('error');
        isValid = false;
      }
    });

    if (!isValid) {
      errorMessage.textContent = isPhoneValid
        ? "Please fill out all required fields."
        : "Please fill out your mobile phone number in International Format, example: +61456789012";
    }

    return isValid;
  }

  function request_redeem_giftcard(
    encrypted_voucher_id,
    voucher_id,
    activity_sku,
    giftcard_sku,
    giftcard_value,
    cust_email,
    cust_first_name,
    cust_last_name,
    cust_phone,
    passpin,
    timestamp) {
    var param = {
      "encrypted_id": encrypted_voucher_id,
            "voucher_id": voucher_id,
            "timestamp": timestamp,
            "passpin": passpin,
            "recipient_first_name": cust_first_name,
      "recipient_last_name": cust_last_name,
      "recipient_email": cust_email,
      "recipient_phone": cust_phone,
      "activity_sku": activity_sku,
      "giftcard_value": giftcard_value,
      "product_code": giftcard_sku?.toUpperCase().replace(/-/g, "_") ?? "TR_WE_WANDER_DIGITAL_VISA_GIFT_CARD"
    };

    var btn = document.querySelector('#submit_redeem');
    btn.classList.add('in-progress');
    btn.value = "In Progress";
    btn.innerHTML = "In Progress";

    // Use fetch (no jQuery dependency)
    fetch('https://www.we-wa.com.au/wp-json/wewander/v2/paymentgiftcard_redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.result == 1) {
        var actionBtn = document.querySelector('#submit_redeem');
        actionBtn.classList.remove('in-progress');
        
        actionBtn.classList.add('success');
        actionBtn.value = "Access Your Gift Card";
        actionBtn.innerHTML = "Access Your Gift Card";
        actionBtn.href = data.data;
        actionBtn.style.display = 'flex';

        var fields = document.querySelector('form .form-fields-columns');
        if (fields) fields.style.display = 'none';

        var ok = document.querySelector('.button-reply-success');
        if (ok) ok.style.display = 'block';
      } else {
        var actionBtn = document.querySelector('#submit_redeem');
        actionBtn.style.display = "none";
        var err = document.querySelector('.button-reply-error');
        if (err) err.style.display = 'block';
        var p = document.querySelector('.button-reply-error p');
        if (p) p.innerHTML = data.message || 'We could not process your request.';
      }
    })
    .catch(function () {
      console.log("Redeem-payment-gift-card failed");
    });
  }

  function request_redeem_compound(encrypted_voucher_id, voucher_id, activity_sku, cust_email, cust_first_name, cust_last_name, cust_phone, passpin, timestamp) {
    var param = {
      "encrypted_id": encrypted_voucher_id,
      "voucher_id": voucher_id,
      "timestamp": timestamp,
      "passpin": passpin,
      "recipient_first_name": cust_first_name,
      "recipient_last_name": cust_last_name,
      "recipient_email": cust_email,
      "recipient_phone": cust_phone
    };

    var btn = document.querySelector('#submit_redeem');
    btn.classList.add('in-progress');
    btn.value = "In Progress";
    btn.innerHTML = "In Progress";

    // Use fetch (no jQuery dependency)
    fetch('https://www.we-wa.com.au/wp-json/wewander/v1/compoundnightout_redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.result == 1) {
        btn.style.display = 'none';

        var fields = document.querySelector('form .form-fields-columns');
        if (fields) fields.style.display = 'none';

        var responseDiv = document.querySelector('#response-container');
        responseDiv.innerHTML = data.data;
      } else {
        btn.style.display = "none";
        var err = document.querySelector('.button-reply-error');
        if (err) err.style.display = 'block';
        var p = document.querySelector('.button-reply-error p');
        if (p) p.innerHTML = data.message || 'We could not process your request.';
      }
    })
    .catch(function () {
      console.log("request_redeem_compound failed");
    });
  }
});
